<template>
    <div>
        <first />
        <second />
        <third />
    </div>
</template>

<script src="./banking.js"></script>
<style src="./banking.css"></style>